// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_oMj5G","label":"index_label_1Q9pC"};